<template>
  <div class="container-main">
    <div class="container-main-header-button">
      <v-btn depressed @click="back">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <span v-if="$route.params.id"> Редактировать ссылку</span>
      <span v-else>Добавить ссылку</span>
    </div>
    <v-form ref="formFirst">
      <div class="container-block">
        <div class="container-block-title">Основная информация</div>
        <div>
          <v-text-field label="Метка" type="text" outlined v-model="item.label"></v-text-field>
        </div>
        <div>
          <v-text-field label="Заголовок" required type="text" outlined :rules="rules"
            v-model="item.title"></v-text-field>
        </div>
        <div>
          <v-textarea label="Описание" type="text" outlined v-model="item.description"></v-textarea>
        </div>
        <div>
          <v-text-field label="Ссылка" required type="text" outlined :rules="[
            (v) => !!v || 'Обязательно к заполнению',
            (v) => checkValidUrl(v) || '',
          ]" v-model="item.link"></v-text-field>
        </div>
      </div>
    </v-form>

    <div class="container-block">
      <div class="container-block-title">
        Параметры публикации и отображения
      </div>
      <div class="d-flex align-center">
        <v-switch v-model="isHidden" hide-details color="var(--app-green-1)"></v-switch>
        <span class="switch-label">Скрыть из списка ссылок (ссылка не будет отображаться)</span>
      </div>
    </div>

    <div v-if="!newImage" class="container-block">
      <div class="container-block-title">Изображение ссылки</div>

      <v-file-input accept="image/*" outlined :rules="[
        (value) =>
          (value && value.size < 104857600) ||
          'Размер изображения не больше 100 мб',
      ]" hint="Максимальный размер изображения 100 мб" persistent-hint v-model="newImage" @change="previewImage"
        label="Прикрепить изображение"></v-file-input>
    </div>

    <div></div>

    <div v-if="newImage" class="container-block" style="width: 100%">
      <div class="container-block-title">Кадрировать изображение</div>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Формат</th>
              <th class="text-left">Место отображенния</th>
              <th class="text-left">Изображение</th>
              <th class="text-right"></th>
            </tr>
          </thead>
          <tbody>
            <tr style="height: 60px">
              <td class="text-left">Изображение ссылки</td>
              <td class="text-left">Основное изображение ссылки</td>
              <td class="text-left">
                <v-btn v-if="!finishImage" @click="openCropImg" class="button-accept"
                  style="width: auto !important">
                  Кадрировать
                </v-btn>

                <div v-else class="d-flex">
                  <img @click="openCropImg" class="table-img" :src="finishImage" />
                  <v-btn outlined @click="openCropImg" color="var(--app-dark-blue-1) "
                    class="button-accept-outlined" style="width: auto !important; margin-left: 10px">
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn icon @click="deleteImage">
                  <v-icon color="var(--app-red-1)"> mdi-delete-outline </v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-alert color="var(--app-red-1)" type="error" v-model="errImages">
        Откадрируйте изображение
      </v-alert>
      <v-divider></v-divider>

      <v-dialog width="800px" height="auto" persistent v-if="imgSrc" v-model="dialogCrop">
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogCrop = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div v-if="imgSrc" class="d-flex justify-space-between">
              <div style="width: 380px; height: 380px">
                <cropper ref="cropper" :src="imgSrc" style="width: 450px; height: 450px" :stencil-props="{
                  handlers: {},
                  movable: false,
                  scalable: true,
                }" :canvas="{
  maxHeight: 600,
  maxWidth: 600,
}" :stencil-size="{
  width: 300,
  height: 300,
}" image-restriction="stencil" @change="onChangeCrop" />
              </div>

              <div class="d-flex justify-center" style="width: 100%" v-if="resultImage">
                <img width="300px" height="300px" :src="resultImage" />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeCropImg()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-alert color="var(--app-red-1)" type="error" v-model="errImagesMain">
      Прикрепите изображение
    </v-alert>

    <div class="container-block-footer-buttons">
      <div>
        <v-btn @click="saveItem" :loading="saving" style="width: auto !important" class="button-accept">
          Сохранить
        </v-btn>
      </div>
      <div>
        <v-btn v-if="$route.params.id" @click="dialogDelete = true" outlined style="width: auto !important"
          color="var(--app-red-1)" class="button-accept-outlined">
          Удалить
        </v-btn>
      </div>
    </div>
    <v-dialog width="600px" height="auto" persistent v-model="dialogDelete">
      <v-card>
        <v-card-title class="dialog-title">
          <span class="title">Точно хотите удалить ссылку?</span>
          <v-icon @click="dialogDelete = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-actions class="dialog-buttons">
          <v-btn @click="dialogDelete = false" style="width: 120px" outlined color="var(--app-green-1)">
            Нет
          </v-btn>
          <v-btn @click="deleteItem" style="width: 120px" outlined color="var(--app-red-1)">
            Да
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
  components: {
    Cropper,
  },
  data: () => ({
    item: {
      isVisible: true,
    },

    errImages: false,
    errImagesMain: false,
    dialogCrop: false,
    dialogDelete: false,
    saving: false,

    rules: [(value) => !!value || "Обязательно к заполнению"],

    newImage: null,
    imgSrc: "",
    resultImage: "",
    finishImage: "",
    croppedBlob: null,
  }),

  computed: {
    isHidden: {
      get() {
        return !this.item.isVisible;
      },
      set(value) {
        this.$set(this.item, "isVisible", !value);
      },
    },
  },

  methods: {
    previewImage() {
      this.finishImage = "";
      this.resultImage = "";
      this.croppedBlob = null;
      if (this.newImage) {
        this.imgSrc = URL.createObjectURL(this.newImage);
      } else {
        this.imgSrc = "";
      }
    },

    openCropImg() {
      this.dialogCrop = true;
      setTimeout(() => {
        this.$refs.cropper.refresh();
      }, 500);
      this.errImages = false;
    },

    onChangeCrop({ canvas }) {
      this.resultImage = canvas.toDataURL();
    },

    closeCropImg() {
      this.finishImage = this.resultImage;
      this.dialogCrop = false;
      const { canvas } = this.$refs.cropper.getResult();
      canvas.toBlob(
        (blob) => {
          this.croppedBlob = blob;
        },
        "image/webp",
        0.95
      );
    },

    deleteImage() {
      this.newImage = null;
      this.imgSrc = "";
      this.resultImage = "";
      this.finishImage = "";
      this.croppedBlob = null;
    },

    back() {
      this.$router.push({ name: "Appeal", params: { selectedTicker: 3 } });
    },

    async uploadImage(blob) {
      const formData = new FormData();
      formData.append("file", blob);
      formData.append("path", "candidateKSA");
      const { data } = await this.$axios.post(
        this.$store.getters.apiAdminPanelV5 + "/upload",
        formData,
        {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
            "secret-key": this.$store.state.secretKeyCookie,
          },
        }
      );
      return data;
    },

    async saveItem() {
      if (!this.$refs.formFirst.validate()) return;
      if (!this.newImage) {
        this.errImagesMain = true;
        return;
      }
      if (this.newImage instanceof File && !this.croppedBlob) {
        this.errImages = true;
        return;
      }

      this.saving = true;
      try {
        const image = this.croppedBlob
          ? await this.uploadImage(this.croppedBlob)
          : this.item.image;

        const body = {
          label: this.item.label,
          title: this.item.title,
          description: this.item.description,
          link: this.item.link,
          image,
          isVisible: this.item.isVisible,
        };

        const request = this.item.id
          ? this.$axios.patch(
              this.$store.getters.apiAdminPanelV5 +
                "/appeal/banner/" +
                this.item.id,
              body,
              {
                headers: {
                  authorization: this.$store.getters.adminPanelHeaderAuth,
                  "secret-key": this.$store.state.secretKeyCookie,
                },
              }
            )
          : this.$axios.post(
              this.$store.getters.apiAdminPanelV5 + "/appeal/banner",
              body,
              {
                headers: {
                  authorization: this.$store.getters.adminPanelHeaderAuth,
                  "secret-key": this.$store.state.secretKeyCookie,
                },
              }
            );

        await request;
        this.$router.push({ name: "Appeal", params: { selectedTicker: 3 } });
      } catch (err) {
        this.$store.commit("errorSet", true);
        this.$store.commit("errorTextSet", err);
      } finally {
        this.saving = false;
      }
    },

    getItem() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV5 +
            "/appeal/banner/" +
            this.$route.params.id,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          this.item = res.data;
          this.newImage = res.data.image;
          this.imgSrc = res.data.image;
          this.finishImage = res.data.image;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },

    deleteItem() {
      this.$axios
        .delete(
          this.$store.getters.apiAdminPanelV5 +
            "/appeal/banner/" +
            this.$route.params.id,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then(() => {
          this.$router.push({ name: "Appeal", params: { selectedTicker: 3 } });
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
  },

  created() {
    if (this.$route.params.id) {
      this.getItem();
    }
  },

  watch: {
    newImage() {
      if (this.newImage) {
        this.errImagesMain = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container-main {
  box-sizing: border-box;

  padding: 40px !important;

  .container-main-header-button {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    span {
      font-size: 28px;
      font-weight: 400;
      margin-left: 16px;
    }
  }

  .container-block {
    width: 50%;
    margin-bottom: 20px;

    .container-block-title {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 16px;
    }

    .table-img {
      height: 38px;
      object-fit: contain;
      cursor: pointer;
    }
  }

  .container-block-footer-buttons {
    display: flex;
    justify-content: space-between;
    width: 50%;
    margin-top: 60px;
  }
}

.switch-label {
  font-size: 16px;
  color: #0000009a;
  margin-bottom: 2px;
}
</style>
